import React from 'react';

const SearchBarSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      {/* Search Input Skeleton - matches exact structure */}
      <div className="relative flex-1 animate-pulse">
        <div className="w-full h-12 bg-gray-200 rounded-full border border-gray-300" />
      </div>
    </div>
  );
};

export default SearchBarSkeleton;
